const SUPPORTED_COUNTRIES = [
    'US',
    'CA'
];
const COUNTRY_LANGUAGES = {
    US: [
        'en'
    ],
    CA: [
        'en',
        'fr'
    ]
};
const DEFAULT_LOCALE = 'default-locale';
const LOCALE_FORMAT = '{{language}}-{{country}}';
const formatLocale = (country, language)=>LOCALE_FORMAT.replace('{{country}}', country).replace('{{language}}', language);
const ABSOLUTE_LOCALES = SUPPORTED_COUNTRIES.flatMap((country)=>COUNTRY_LANGUAGES[country].map((language)=>formatLocale(country, language)));
const ALL_LOCALES = [
    DEFAULT_LOCALE,
    ...SUPPORTED_COUNTRIES,
    ...ABSOLUTE_LOCALES
];

export { ABSOLUTE_LOCALES, ALL_LOCALES, COUNTRY_LANGUAGES, DEFAULT_LOCALE, LOCALE_FORMAT, SUPPORTED_COUNTRIES, formatLocale };
//# sourceMappingURL=i18n.constants.js.map
